import { useRef } from 'react';

const DRAG_THRESHOLD_PX = 4;

export function useDragScroll<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const state = useRef({ isDown: false, startX: 0, scrollLeft: 0, dragged: false });

  const onMouseDown = (e: React.MouseEvent) => {
    const el = ref.current;
    if (!el) return;
    state.current.isDown = true;
    state.current.dragged = false;
    state.current.startX = e.clientX;
    state.current.scrollLeft = el.scrollLeft;
  };

  const stopDragging = () => {
    state.current.isDown = false;
  };

  const onMouseMove = (e: React.MouseEvent) => {
    const el = ref.current;
    if (!el || !state.current.isDown) return;
    const walk = e.clientX - state.current.startX;
    if (Math.abs(walk) > DRAG_THRESHOLD_PX) {
      state.current.dragged = true;
      e.preventDefault();
    }
    el.scrollLeft = state.current.scrollLeft - walk;
  };

  const consumeDragged = () => {
    const wasDragged = state.current.dragged;
    state.current.dragged = false;
    return wasDragged;
  };

  return {
    ref,
    onMouseDown,
    onMouseMove,
    onMouseUp: stopDragging,
    onMouseLeave: stopDragging,
    consumeDragged,
  };
}
